import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { useSearchUnderwritingActivityType } from '@services/underwritingReferral/useSearchUnderwritingActivityType';

export interface UnderwritingActivityTypeTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

export const UnderwritingActivityTypeTypeaheadFilter = (
  componentProps: UnderwritingActivityTypeTypeaheadFilterProps,
) => {
  const { value, disabled } = componentProps;
  const { underwritingActivityTypes, isFetching } = useSearchUnderwritingActivityType();

  const options = (underwritingActivityTypes ?? [])
    .slice()
    .sort((a, b) => a.label.localeCompare(b.label))
    .map((item) => ({ key: item.id, label: item.label, value: item.id }));

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={options}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      loading={isFetching}
      horizontalLabel={true}
    />
  );
};
